function banner(backendAxiosInstance) {
  async function getCurableBanner(bannerId) {
    return backendAxiosInstance.get("/layouts/v4/banner", {
      params: {
        bannerId
      }
    });
  }
  return {
    getCurableBanner
  };
}

export { banner as default };
//# sourceMappingURL=banner.js.map
